"use client";

import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import { useTranslations } from "next-intl";

// Icônes Solar, comme partout ailleurs sur la plateforme. Variante au trait :
// ce sont des filtres, pas des accents, et un seul élément doit ressortir, celui
// qui est actif.
const categories = [
    {
        id: "all",
        icon: null,
    },
    {
        id: "developers",
        icon: "programming-linear",
    },
    {
        id: "entrepreneurs",
        icon: "case-minimalistic-linear",
    },
    {
        id: "nocode",
        icon: "bolt-linear",
    },
];

export default function ArticlesCategoryFilter({ category, onCategoryChange }) {
    const t = useTranslations();

    return (
        <div className="flex gap-2 flex-wrap">
            {categories.map((cat) => {
                const isActive = category === cat.id || (!category && cat.id === "all");

                return (
                    <button
                        key={cat.id}
                        onClick={() => onCategoryChange(cat.id)}
                        className={`
                            flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm
                            transition-all duration-200 whitespace-nowrap
                            ${
                                isActive
                                    ? "bg-primary text-white shadow-md shadow-primary/25"
                                    : "bg-gray-100 dark:bg-grayDark-800 text-gray-700 dark:text-grayDark-300 hover:bg-gray-200 dark:hover:bg-grayDark-700"
                            }
                        `}
                    >
                        {cat.icon && <SolarIcon name={cat.icon} className="w-4 h-4" />}
                        <span>{t(`courses_category_${cat.id}`)}</span>
                    </button>
                );
            })}
        </div>
    );
}
